<template>
  <div :class="classes" :style="styles"><slot /></div>
</template>

<script>
export default {
  name: 'Asd20Viewport',
  props: {
    scrollable: { type: Boolean, default: false },
    padded: { type: Boolean, default: false },
    maxHeight: { type: String, default: '' },
  },
  computed: {
    classes() {
      return {
        'asd20-viewport': true,
        'asd20-viewport--scrollable': this.scrollable,
        'asd20-viewport--padded': this.padded,
      }
    },
    styles() {
      return {
        'max-height': this.maxHeight ? this.maxHeight : 'auto',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../design/_mixins.scss';
@import '../../../design/_variables.scss';
.asd20-viewport {
  flex-grow: 1;
  overflow: hidden;
  position: relative;
  &--scrollable {
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  &--padded {
    padding: space(1);
  }
  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: var(--website-page__alternate-background-color);
    border-radius: 4px;
    margin: 3px;
  }
}
</style>